import DeleteOrUpdate from './DeleteOrUpdate';
export default DeleteOrUpdate;
